import { useMediaQuery } from 'react-responsive';

export const useMd = () =>
  useMediaQuery({
    minWidth: 720,
  });
